export interface ExplainState {
  pageLayout: ExplainLayout[]
  settings: {
    dateRange: string
    loading: boolean
  }
}

export const initialState = {
  pageLayout: [],
  settings: {
    dateRange: '',
    loading: true,
  },
}

export const explain = (
  state: ExplainState = initialState,
  action: ReduxAction,
): ExplainState => {
  switch (action.type) {
    case 'START_LOADING_EXPLAIN_SETUP':
      return {
        ...state,
        settings: {
          ...state.settings,
          loading: true,
        },
      }
    case 'GET_EXPLAIN_SETUP':
      return {
        ...state,
        pageLayout: action.payload.pageLayout,
        settings: {
          loading: false,
          ...action.payload.settings,
        },
      }
    case 'SAVE_EXPLAIN_SETUP':
      return {
        ...state,
        pageLayout: action.payload.pageLayout,
        settings: action.payload.settings,
      }
    default:
      return state
  }
}
